export const THEME_STORAGE_KEY = 'core-utils-theme';
export const LEGACY_THEME_STORAGE_KEY = 'vite-ui-theme';
export const DEFAULT_THEME = 'dark';
